export default {
  copyright: 'Copyright © KEY LEARNING SpA {year}. Todos los derechos reservados.',
}
